import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'

import _ from 'lodash'
import uuid from 'uuid/v1'
import {Transition, TransitionGroup} from 'react-transition-group'
import NRTFormStateManager from "../../../../components/_common/_form/FormStateManager/index"
import NRTButton from "../../../../components/_common/_buttons/Button/index"
import NRTSectionForm from "../../../../components/_admin/SectionForm"
import CirclePlus from "../../../../components/_common/_icons/CirclePlus"
import NRTModal from "../../../../components/_common/Modal"
import NRTVerticalStack from "../../../../components/_common/_containers/VerticalStack"


const AdminSectionContentType = {
    Produto: 1,
    Servico: 2,
    Curso: 3
}


class TabSectionConfig extends Component {

    state = {
        sections: [] ,
        confirmDialogOpen: false,
        removingSectionId: null,
    }


    componentDidMount() {
        this.setState({
            sections: this.props.sections || []
        })
    }



    addSection = () => {

        console.log('add section')
        const newSection = this.createSectionDTO()

        this.setState({
            sections: [...this.state.sections, newSection]
        })

    }


    createSectionDTO(
        id = uuid(),
        title = 'Nova seção',
        contentType = AdminSectionContentType.Curso,
        courseType = 3,
        showReleaseData = true,
        nameVisible = false,
        descriptionVisible = false,
        imageVisible = false,
        valueVisible = false,
        locationVisible = false,
        dateVisible = false,
        statusVisible = false,
        typeVisible = false,
        workloadVisible = false
    ) {
        return ({
            id,
            title,
            contentType,
            courseType,
            showReleaseData,
            visibleContentFields: {
                name: nameVisible,
                description: descriptionVisible,
                image: imageVisible,
                value: valueVisible,
                location: locationVisible,
                date: dateVisible,
                status: statusVisible,
                type: typeVisible,
                workload: workloadVisible
            },

        })
    }


    showConfirmRemoveDialog = (id) => {
        this.setState({
            confirmDialogOpen: true,
            removingSectionId: id,
        })

    }

    closeRemoveModal = () => {
        this.setState({
            confirmDialogOpen: false,
            removingSectionId: null
        })
    }


    confirmRemoveSection = () => {
        const newSections = this.props.sections.filter(s => s.id !== this.state.removingSectionId)
        this.props.onSave(newSections)
        this.setState({sections:newSections})
        this.closeRemoveModal()
    }


    save = (section) => {
        const sections = [...this.props.sections]
        const updatingSectionIndex = _.findIndex(sections, s => s.id === section.id)

        if (updatingSectionIndex >= 0)
            sections[updatingSectionIndex] = section
        else
            sections.push(section)

        this.props.onSave(sections)
        this.setState({sections})
    }



    render() {

        const {sections} = this.state

        if (!sections)
            return null

        return (
            <div className="section-config-form">

                <NRTModal title={'Deseja remover esta seção?'}
                          open={this.state.confirmDialogOpen}
                          onOverlayClick={this.closeRemoveModal}
                          buttons={[
                              <NRTButton content={'cancelar'}
                                         onClick={this.closeRemoveModal}
                                         outline
                              />,
                              <NRTButton content={'remover'}
                                         onClick={this.confirmRemoveSection}
                                         danger
                              />
                          ]}
                />


                <NRTFormStateManager ref={f => this.form = f} onStateChange={this.onFormChange}>
                    <NRTVerticalStack>
                        <NRTButton onClick={this.addSection}>
                            <CirclePlus/> Adicionar Seção
                        </NRTButton>
                        <TransitionGroup>

                            {
                                sections.map((section) =>
                                    <Fade key={'sectionform-' + section.id}>
                                        <NRTSectionForm
                                            section={section}
                                            onRemoveSectionButtonClick={this.showConfirmRemoveDialog}
                                            onSaveSection={this.save}
                                        />
                                    </Fade>
                                )
                            }

                        </TransitionGroup>
                    </NRTVerticalStack>
                </NRTFormStateManager>


            </div>
        )
    }
}


const Fade = ({children, ...props}) => {

    const defaultStyle = {
        display: 'inline=block',
        transition: `all .3s ease`,
        opacity: 0,
        maxHeight: 0,
        height: '100%',
    }

    const transitionStyles = {
        entering: {
            opacity: 0,
            maxHeight: 0,
        },
        entered: {
            opacity: 1,
            maxHeight: '55px',
        },
        exited: {
            display: 'none'
        }
    };

    return (
        <Transition enter={false} timeout={300} in={props.in}>
            {(state) => (
                <span
                    onClick={props.onClick}
                    style={{
                        ...defaultStyle,
                        ...transitionStyles[state],
                        ...props.style,
                    }}>
                    {children}
                </span>
            )}
        </Transition>
    )
}


TabSectionConfig.propTypes = {
    onSave: PropTypes.func.isRequired,
    sections: PropTypes.array.isRequired,
}

export default TabSectionConfig



// WEBPACK FOOTER //
// ./src/_pages/Admin/_partials/TabSectionsConfig/index.js